import React from "react";
import { amountInWordsInr, formatInr } from "../../utils/financeFormat";

/**
 * Highlighted total banner (gradient + shadow) — used on monthly cost / finance tabs.
 * Pass amountRupee for automatic in-words subtitle on totals.
 */
export default function AnalyticsStatHero({ label, value, amountRupee, meta, valueClassName = "" }) {
  const hasAmount = amountRupee != null && amountRupee !== "";
  const display = hasAmount ? formatInr(amountRupee) : value;
  const words = hasAmount ? amountInWordsInr(amountRupee) : "";

  return (
    <div className="analytics-stat-hero mb-3">
      <div>
        {label ? <div className="stat-hero-label">{label}</div> : null}
        <div className={`stat-hero-value${valueClassName ? ` ${valueClassName}` : ""}`}>{display}</div>
        {words && words !== "Zero" ? <div className="stat-hero-words">{words}</div> : null}
      </div>
      {meta ? <div className="text-secondary small text-end">{meta}</div> : null}
    </div>
  );
}

export { formatInr };
export { formatInrWithWords } from "../../utils/financeFormat";
